import config from "../config/config.json";
import { headers } from "./../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const documentTagServices = {
  getDocumentTagData,
  addNewDocumentTag,
  updateDocumentTagData,
  softDeleteRestoreDocumentTag,
  deleteDocumentTagData,
};

async function addNewDocumentTag(userData) {
  const response = await fetch(
    `${config.API_URL}addNewDocumentTag`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function updateDocumentTagData(userData) {
  const response = await fetch(
    `${config.API_URL}updateDocumentTag`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function softDeleteRestoreDocumentTag(userData) {
  const response = await fetch(
    `${config.API_URL}softDeleteRestoreDocumentTag`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function deleteDocumentTagData(userData) {
  const response = await fetch(
    `${config.API_URL}deleteDocumentTagData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function getDocumentTagData(status, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL}getDocumentTagData/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL}getDocumentTagData/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}